import * as React from 'react';
import { Grid, Row, Col } from '@cian/ui-kit';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

import { VIEWED_TIMEOUT } from '../../../constants/viewedBlock';

import { Wrapper } from '../../../components/Wrapper';
import { Section } from '../../../components/Section';

import { trackOffersHistoryView } from '../../../utils/teaser';

import { ValuationFiltersContainer } from '../../ValuationFiltersContainer';
import { MarketPriceContainer } from '../../MarketPriceContainer';
import { SendReportContainer } from '../../SendReportContainer';
import { PageAside } from '../../../components/PageAside';
import { ViewAllReportContainer } from '../../ViewAllReportContainer';
import { EScrollingBlocks } from '../../../constants/scrollingBlocks';
import { useScrollingRef } from '../../Scrolling';
import { HeroResultSectionContainer } from '../../HeroResultSectionContainer';
import { StickyFooterContainer } from '../../StickyFooterContainer';
import { TabsContainer } from '../../TabsContainer';
import { NotificatorContainer } from '../../NotificatorContainer';
import { useIsReportStatusDefault } from '../../../utils/report';
import { AboutHomeContainer } from '../../AboutHomeContainer';
import { ValuationContentContainer } from '../../ValuationContentContainer';
import { EstimationChartContainer } from '../../EstimationChartContainer';
import { OfferHistoryContainer } from '../../OfferHistory/Desktop';
import { EstimationDealTypeBannerContainer } from '../../EstimationDealTypeBannerContainer';
import { useSelector } from 'react-redux';
import { selectDealType } from '../../../selectors/page';
import { selectEstimationByDealType } from '../../../selectors/estimation';
import { ErrorScreen } from '../../../components/ErrorScreen';
import { RateOurEstimationContainer } from '../../RateOurEstimationContainer';
import { InfrastructureContainerLoad } from '../../InfrastructureMapContainer';

export function DesktopPageContainer() {
  const isReportStatusDefault = useIsReportStatusDefault();
  const valuationFiltersRef = useScrollingRef(EScrollingBlocks.ValuationFilters);
  const marketPriceRef = useScrollingRef(EScrollingBlocks.MarketPrice);
  const aboutHomeRef = useScrollingRef(EScrollingBlocks.AboutHome);
  const estimationChartRef = useScrollingRef(EScrollingBlocks.EstimationChart);
  const offersHistoryRef = useScrollingRef(EScrollingBlocks.OffersHistory);
  const dealTypeTabsRef = useScrollingRef(EScrollingBlocks.DealTypeTabs);
  const infrastructureRef = useScrollingRef(EScrollingBlocks.Infrastructure);

  const dealType = useSelector(selectDealType);
  const estimation = useSelector(selectEstimationByDealType(dealType));

  if (estimation.isError) {
    return <ErrorScreen />;
  }

  return (
    <>
      <HeroResultSectionContainer />
      <ValuationFiltersContainer refWrapper={valuationFiltersRef} />
      <Wrapper>
        <ValuationContentContainer>
          <Grid>
            <Row>
              <Col xs={9}>
                <Section marginTop={60} marginBottom={32}>
                  <TabsContainer refWrapper={dealTypeTabsRef} />
                  <EstimationDealTypeBannerContainer />
                </Section>
                <Section marginTop={/* istanbul ignore next */ !isReportStatusDefault ? 60 : undefined}>
                  <MarketPriceContainer refWrapper={marketPriceRef} />
                  <RateOurEstimationContainer />
                </Section>
                <Section>
                  <EstimationChartContainer refWrapper={estimationChartRef} />
                </Section>
                <Section>
                  <ActionAfterViewObserver callbackDelay={VIEWED_TIMEOUT} callback={trackOffersHistoryView}>
                    <OfferHistoryContainer refWrapper={offersHistoryRef} />
                  </ActionAfterViewObserver>
                </Section>
                <Section>
                  <AboutHomeContainer refWrapper={aboutHomeRef} />
                </Section>
                <Section>
                  <InfrastructureContainerLoad refWrapper={infrastructureRef} />
                </Section>
                <Section>
                  <SendReportContainer />
                </Section>
              </Col>
              <Col xs={3}>
                <PageAside>
                  <ViewAllReportContainer />
                </PageAside>
              </Col>
            </Row>
          </Grid>
        </ValuationContentContainer>
      </Wrapper>
      <StickyFooterContainer />
      <NotificatorContainer />
    </>
  );
}
